/* eslint-disable react/no-deprecated */
import React, { Component } from "react"
import PropTypes from "prop-types"
import slugify from "slugify"
import _omit from "lodash/omit"
import ThemeConsumer from "../ThemeConsumer"
import Loading from "../loading/"

class FloatLabelSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
      changed: false
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.handleChange({ target: { value: nextProps.value } })
    }
  }

  hasDefaultOptionValue() {
    return !(
      this.props.options[0].value === null ||
      this.props.options[0].value === undefined ||
      !String(this.props.options[0].value).length
    )
  }

  getDefaultOptionValue() {
    return this.hasDefaultOptionValue() ? undefined : ""
  }

  handleChange = (ev) => {
    // if (this.props.loading) return null
    // return this.setState({
    this.setState({
      value: ev.target.value,
      changed: true
    })
  }

  handleErrorClose = () => {
    this.setState(
      {
        value: ""
      },
      () => {
        if (this.props.onChange && typeof this.props.onChange === "function") {
          this.props.onChange(this.state.value)
        }
      }
    )
  }

  canRemoveDefaultOption = () => {
    return (
      this.props.defaultOption &&
      this.props.removeDefaultOption &&
      !this.state.changed
    )
  }

  preppendDefaultOption = () => {
    return this.props.defaultOption && !this.props.removeDefaultOption
  }

  renderOptions() {
    const options = []

    // if(this.hasDefaultOptionValue() && this.props.defaultOption){
    //   options.push(<option key="nullOption" />)
    // }
    if (this.preppendDefaultOption() || this.canRemoveDefaultOption()) {
      options.push(<option key="nullOption" />)
    }

    this.props.options.forEach((item, index) => {
      if (!index) {
        if (
          (item.value &&
            (item.value === null ||
              item.value === undefined ||
              !String(item.value).length)) ||
          (!item.value && item.value !== 0)
        ) {
          return options.push(
            <option
              disabled
              selected
              key={`${item.label}_${item.value}`}
              value={item.value}
            >
              {item.label}
            </option>
          )
        }
      }
      return options.push(
        <option key={`${item.label}_${item.value}`} value={item.value}>
          {item.label}
        </option>
      )
    })

    return options
  }

  render() {
    const uid = slugify(this.props.label || this.props.id, { lower: true })
    const { theme } = this.props

    return (
      <div
        className={`
          ${theme.floatLabel}
          ${this.props.invalid ? theme.invalid : ""}
          ${this.props.icon ? theme.hasIcon : ""}
          ${this.props.disabled ? theme.disabled : ""}
          ${this.props.classNames}
        `}
      >
        <select
          disabled={this.props.disabled}
          key={uid}
          id={this.props.id}
          onChange={this.handleChange}
          ref={(ref) => {
            this[uid] = ref
          }}
          className={
            this.state.value === undefined || this.state.value.length
              ? theme.hasValue
              : ""
          }
          value={this.state.value}
          {..._omit(this.props, ["options", "theme"])}
        >
          {this.renderOptions()}
        </select>
        {this.props.label && (
          <label htmlFor={this.props.id}>
            <span>{this.props.label}</span>
            {this.props.required && <span className={theme.required}> *</span>}
          </label>
        )}
        {this.props.invalid && (
          <button
            onClick={this.handleErrorClose}
            className={theme.errorClose}
            type="button"
            tabIndex={-1}
          >
            {/* <Erro
                height={18}
                width={18}
              /> */}
          </button>
        )}
        <span className={theme.error}>
          {this.props.invalid && this.props.error}
        </span>
        {/* <span
          className={theme.icon}
          onClick={() => this[uid].focus()}
          onKeyPress={() => {}}
          role="button"
          tabIndex={-1}
        >
          <img src={IconArrow} />
        </span> */}
        {this.props.loading ? (
          <span className={theme.loading}>
            <Loading model="secondary" size={21} />
          </span>
        ) : (
          ""
        )}
      </div>
    )
  }
}

FloatLabelSelect.propTypes = {
  error: (props, propName) => {
    if (
      props.invalid &&
      (!props[propName] || typeof props[propName] !== "string")
    ) {
      return new Error("Please provide an string error!")
    }
    return null
  },
  invalid: PropTypes.bool,
  defaultOption: PropTypes.bool,
  label: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.object,
  removeDefaultOption: PropTypes.bool,
  id: PropTypes.string,
  classNames: PropTypes.string
}

FloatLabelSelect.defaultProps = {
  error: "",
  defaultOption: false,
  invalid: false,
  required: false,
  icon: "",
  disabled: false,
  loading: false
}

export default ThemeConsumer("UIFloatLabel")(FloatLabelSelect)



// WEBPACK FOOTER //
// ./src/shared/components/FloatLabelSelect/index.js